import { useState } from "react";
import { applyScale, getStoredScale, SCALES } from "@/lib/textScale";

export const TextSizeToggle = ({ light = false }) => {
  const [current, setCurrent] = useState(getStoredScale);

  const choose = (id) => {
    applyScale(id);
    setCurrent(id);
  };

  return (
    <div
      role="group"
      aria-label="Dimensione del testo"
      data-testid="text-size-toggle"
      className={`flex items-center gap-1 rounded-full border p-1 ${light ? "border-ivory/25" : "border-navy/15"}`}
    >
      {SCALES.map((s, i) => {
        const active = current === s.id;
        const tone = light ? (active ? "bg-ivory text-navy" : "text-ivory hover:bg-ivory/10") : active ? "bg-navy text-ivory" : "text-navy hover:bg-navy/5";
        return (
          <button
            key={s.id}
            type="button"
            aria-pressed={active}
            aria-label={s.label}
            title={s.label}
            onClick={() => choose(s.id)}
            data-testid={`text-size-${s.id}`}
            className={`grid h-10 w-10 place-items-center rounded-full font-display font-semibold leading-none transition-colors duration-300 ${tone}`}
            style={{ fontSize: `${15 + i * 4}px` }}
          >
            A
          </button>
        );
      })}
    </div>
  );
};
